import { Middleware } from 'redux';

import * as appConstants from 'redux/constants/app.constants';
import * as blogsConstants from 'redux/constants/blogs.constants';
import * as servicesConstants from 'redux/constants/services.constants';

import { showErrorNotification } from 'helpers/notifications';

const notificationMiddleware: Middleware = () => (next) => (action) => {
  const { error, type } = action;
  switch (type) {
    case appConstants.APP_ON_GET_LAST_BLOGS_FAILED:
    case blogsConstants.BLOGS_ON_GET_ALL_FAILED:
    case blogsConstants.BLOGS_ON_GET_ONE_FAILED:
    case servicesConstants.SERVICES_ON_GET_ALL_FAILED:
      showErrorNotification(error.response?.data?.message || error.message);
      break;
    case appConstants.APP_ON_CONTACT_FAILED:
      if (error.response?.data?.errors)
        error.response.data.errors.forEach((message: string) => showErrorNotification(message));
      else showErrorNotification(error.response?.data?.message || error.message);
      break;
    default:
      break;
  }
  return next(action);
};

export default notificationMiddleware;
